import { render, staticRenderFns } from "./SecuriteBien.vue?vue&type=template&id=3a54b022&"
import script from "./SecuriteBien.vue?vue&type=script&lang=js&"
export * from "./SecuriteBien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports